import React, { Component } from 'react';
import nbnIcon from './../../../../src/assets/img/nbn-icon.svg';
import mobileIcon from './../../../../src/assets/img/mobile-icon.svg';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import './../../../../src/assets/css/nbn_page.css';
import axios from 'axios';
import { getApiHeader } from '../../../utils/CommonFunctions';
import swal from 'sweetalert';
import PageLoader from '../../Loader/loader';


const SERVER_URL = process.env.REACT_APP_SERVER_URL;

class PostPaidServiceList extends Component {

  state = {
    customer_cards: [],
    loading: true,
    clientToken: null,
    customerId: null,
    nbn_plan_details: [],
    activation_details: [],
    // activated_plan_data: [],
    nbn_activation_expiry_date: "",
    service_address: '',
    activation_post_paid_services:[],
    is_wme_customer:0

  }


  componentDidMount() {
    this.getMyservices();
  }

  getMyservices = async () => {

    this.setState({ loading: true });
    let headers = await getApiHeader();
    const post_data = {
      nbn_activation_id: sessionStorage.getItem('nbn_activation_id')
    };
    await axios.post(`${SERVER_URL}my-services-list`, post_data, { headers }).then(response => {

      // console.log(response.data.data.data);
      if (response.data.data.data.customMessage) {
        if (response.data.data.customMessage !== 'undefined') {
          this.setState({ customMesssge: response.data.data.customMessage });
        }
      }
      let data = response.data.data.data;

      const customerDetail = response?.data?.data?.data?.customer_detail;
      if (customerDetail) {
        const { is_nbn, is_postpaid, is_prepaid, is_wme_customer } = customerDetail;
        if (is_nbn == 1) {
          sessionStorage.setItem('is_nbn', is_nbn);
        }

        if (is_postpaid == 1) {
          sessionStorage.setItem('is_postpaid', is_postpaid);
        }

        if (is_prepaid == 1) {
          sessionStorage.setItem('is_prepaid', is_prepaid);
        }
        if (is_wme_customer == 1) {
          this.setState({ is_wme_customer:1 });
        }else{
          this.setState({ is_wme_customer:0 });
        }
      }

      if (response.data.data.data.nbn_activation.plan) {
        this.setState({ nbn_plan_details: response.data.data.data.nbn_activation.plan })
      }
      // console.log('data.nbn_activation.service_address', data.nbn_activation.service_address);
      if (data.nbn_activation) {
        this.setState({ service_address: data.nbn_activation.service_address })
      }
      // console.log('service_address', this.state.service_address);


      if (data.telsim_customer_id) {
        this.setState({ customerId: data.telsim_customer_id })
      }
      if (response.data.data.data.activation) {

        this.setState({
          activation_details: response.data.data.data.activation,
          // activated_plan_data: response.data.data.data.activation.activated_plan_data
        })
      }
      if (response.data.data.data.postpaid_activation) {

         console.log("response.data.data.data.postpaid_activation-->",response.data.data.data.postpaid_activation)

        this.setState({
          activation_post_paid_services: response.data.data.data.postpaid_activation,
        })
      }
      

      this.setState({ loading: false });
      //console.log('----------------',this.state.activation_details);

    }).catch(error => {

      this.setState({ loading: false });
      if ((typeof (error.response.data.data.data.message) !== 'undefined') && (typeof (error.response.data.data.data) !== 'undefined')) {

        swal({
          text: error.response.data.message,
          allowOutsideClick: false,
          closeOnClickOutside: false,
          icon: "warning"
        }).then(() => {

        });
      }
      else {
        swal("Internal Server Error", "", "warning");
      }
    });
  }

  handleWmePrepaidClick = (is_wme_prepaid) => {
  if (this.state.is_wme_customer === 1 && is_wme_prepaid === 1) {
    sessionStorage.setItem('is_wme_prepaid', 1);
    sessionStorage.setItem('is_wme_customer', 1);
  } else {
    sessionStorage.setItem('is_wme_prepaid', 0);
    sessionStorage.setItem('is_wme_customer', 0);
  }
}


  handleNormalPrepaidClick = () => {
    sessionStorage.setItem('is_wme_customer', 0);
    sessionStorage.setItem('is_wme_prepaid', 0);
  }










  render() {

    // console.log("activation_post_paid_services========>",this.state.activation_post_paid_services)
    return (
      <>

        {(this.state.loading === true) ? <PageLoader /> : null}

        <div className="container">
          <section className="nbn-my-account">
            <div className="nbn-my-service">
              <div className="row">
                <div className="col-md-7">
                  <h3>MY SERVICES</h3>
                </div>
                <div className="col-md-5">
                  <p>Customer ID : <span>CUS-{this.state.customerId}</span></p>
                </div>
              </div>
            </div>

            {sessionStorage.getItem('is_nbn') === '1' && <div className="nbn-data-section">
              <div className="row">
                <div className="col-md-1 py-4">
                  <center><img src={nbnIcon} alt="NBN icon" /></center>
                </div>
                <div className="col-md-4 py-4">
                  <div className="nbn-data-content">
                   <center>  <p>{this.state.service_address}</p></center>
              <center>  <strong>{this.state.nbn_plan_details ? this.state.nbn_plan_details.plan_display_name : ''}</strong> </center> 
              <center> <p className="nbn-data-unlimited">{this.state.nbn_plan_details.plan_name ? this.state.nbn_plan_details.plan_name : ""} | UNLIMITED</p> </center> 
                  </div>
                </div>
                <div className="col-md-5 py-4">
                  <div className="nbn-data-table">
                    <table className="table table-borderless tab-list">
                      <tbody>
                        <tr>
                          <td style={{ textAlign: 'right' }}>Billing Cycle Ends</td>
                          <td>
                            <div className="nbn-progress">
                              <div className="nbn-skills" style={{ '--progress-width': '50%' }} />
                            </div>
                          </td>
                          <td style={{ textAlign: 'left', fontWeight: 600 }}></td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: 'right' }}>Data</td>
                          <td>
                            <div className="nbn-progress">
                              <div className="nbn-skills" style={{ '--progress-width': '40%' }} />
                            </div>
                          </td>
                          <td style={{ textAlign: 'left', fontWeight: 600 }}> {this.state.nbn_plan_details.plan_name ? this.state.nbn_plan_details.plan_name : ''} UNLIMITED</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-md-2 py-4">
                  <center><a href="/nbn-my-account-summary"><button type="button" className="btn btn-danger btn-data">Manage <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></button></a></center>
                </div>
              </div>
            </div>}

            <br />



            {this.state.activation_details.map((activationDetail, index) => (
                    <div className="nbn-data-section2" key={index}>
                      <div className="row">
                        <div className="col-md-1 py-4">
                          <center><img src={nbnIcon} alt="mobile icon" /></center>
                        </div>
                        <div className="col-md-4 py-4">
                          <div className="nbn-data-content">
                      <center>  <p>{activationDetail.mobile_number}</p>  </center>
                      {activationDetail?.activated_old_plan_data ? (
                        <>
                          <center>
                            <strong>









                              {activationDetail?.activated_old_plan_data?.offerName
                                ? activationDetail?.activated_old_plan_data?.offerName
                                : "Telsim Prepaid Plan"}
                            </strong>
                          </center>
                          <center>
                            <p className="nbn-data-unlimited">
                              {activationDetail?.activated_old_plan_data?.my_service_plan_display_name ?? ''}
                            </p>
                          </center>
                        </>
                      ) : (
                        <>
                          <center>
                                  <strong>
                                    { activationDetail?.activated_plan_data?.amount > activationDetail?.activated_plan_data?.sell_amount ?
                                    <>
                                     {activationDetail?.activated_plan_data?.total_data} GB{" "}
                                    <del>${activationDetail?.activated_plan_data?.amount}</del>
                                    {" $"}{activationDetail?.activated_plan_data?.sell_amount}
                                    {"(" + activationDetail?.activated_plan_data?.offer_validity + ` ${ activationDetail?.activated_plan_data?.offer_validity == 1 ? "Month" : "Months"} Offer` + ") " + "Prepaid Plan"}
                                    </>
                                    :activationDetail.activated_plan_data.offerName
                                      ? activationDetail.activated_plan_data.offerName
                                      : "Telsim Prepaid Plan"}
                                  </strong>
                                </center>
                          <center>
                            <p className="nbn-data-unlimited">
                              {activationDetail.activated_plan_data.my_service_plan_display_name ?? ''}
                            </p>
                          </center>
                        </>
                      )}
                    </div>
                        </div>
                        <div className="col-md-5 py-4">
                          <div className="data-table">
                            <table className="table table-borderless tab-list">
                              <tbody>
                                <tr>
                                  <td style={{ textAlign: 'right' }}>Allowances Reset</td>
                                  <td>
                                    <div className="progress">
                                      <div className="nbn-skills" style={{ '--progress-width': '40%' }} />
                                    </div>
                                  </td>
                                  <td style={{ fontWeight: 600, textAlign: 'left' }}>{activationDetail.expiry_date}</td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'right' }}>Validity</td>
                                  <td>
                                    <div className="nbn-progress"></div>
                                  </td>
                                  <td style={{ fontWeight: 600, textAlign: 'left' }}>Every {activationDetail.activated_plan_data.validity} Days</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-2 py-4">
                          <center>
                            <Link
                              onClick={()=>this.handleNormalPrepaidClick()}
                              to={{
                                pathname: "/home",
                                state: {selectedNumber:activationDetail.mobile_number,
                                  selectedActivation:activationDetail.activation_id
                                }
                              }}
                              className="kt-menu__link active"
                            >
                              <button type="button" className="btn btn-danger btn-data">
                                Manage <i className="fa fa-arrow-circle-right" aria-hidden="true"></i>
                              </button>
                            </Link>
                          </center>
                        </div>
                      </div>
                    </div>
                  ))
                }
            <br />
            
            {this.state.activation_post_paid_services.map((postPaidDetail, index) => (
                    <div className="nbn-data-section2" key={index}>
                      <div className="row">
                        <div className="col-md-1 py-4">
                          <center><img src={nbnIcon} alt="mobile icon" /></center>
                        </div>
                        <div className="col-md-4 py-4">
                          <div className="nbn-data-content">
                        <center> <p>{postPaidDetail.mobile_number}</p> </center>
                         <center>  <strong> 

                        {postPaidDetail.offer_data ? (
                          <span>
                          {postPaidDetail.offer_data.plan_name}{" "}
                          
                          <span style={{ textDecoration: "line-through"}}>
                            ${postPaidDetail.offer_data.plan_price}
                          </span>{" "}
                          
                          ${postPaidDetail.offer_data.plan_sell_price}{" "}
                          {postPaidDetail.offer_data.validity}
                        </span>
                        ) :
                          <>
                            <strong>
                              {postPaidDetail?.activated_plan_data.amount > postPaidDetail?.activated_plan_data.sell_amount &&postPaidDetail?.promotional_offer_status===1 ? (
                                <>
                                  {postPaidDetail?.activated_plan_data?.data} GB&nbsp;
                                  <del>${postPaidDetail?.activated_plan_data?.amount}</del>&nbsp;
                                  ${postPaidDetail?.activated_plan_data?.sell_amount}&nbsp;
                                  {"("}
                                  {postPaidDetail?.activated_plan_data?.offer_validity}{" "}
                                  {postPaidDetail?.activated_plan_data?.offer_validity === 1 ? "Month" : "Months"} Offer{")"}{" "}
                                 {postPaidDetail?.activated_plan_data?. is_wme_prepaid===1 || postPaidDetail?.activated_plan_data?.is_wme_prepaid === 2? "Telsim Prepaid Plan":"Telsim SIM Only Plan" }                 
                                </>
                              ) : (
                                <>
                                {postPaidDetail.activated_plan_data.plan_name
                                    ? postPaidDetail.activated_plan_data.plan_name
                                    : postPaidDetail?.activated_plan_data?.is_wme_prepaid === 1 || postPaidDetail?.activated_plan_data?.is_wme_prepaid === 2 ? "Telsim Prepaid Plan" : "Telsim SIM Only Plan"}
          
                                  {/* {postPaidDetail.activated_plan_data.plan_name
                                    ? postPaidDetail.activated_plan_data.plan_name
                                    : postPaidDetail?.activated_plan_data?.is_wme_prepaid === 1 || postPaidDetail?.activated_plan_data?.is_wme_prepaid === 2 ? "Telsim Prepaid Plan" : "Telsim SIM Only Plan"} */}
                                </>
                              )}
                            </strong>
                          </>
                        }

                          </strong> </center>
                         <center> <p className="nbn-data-unlimited">{postPaidDetail.activated_plan_data.my_service_plan_display_name ?postPaidDetail.activated_plan_data.my_service_plan_display_name: ''}</p> </center>
                          </div>
                        </div>
                        <div className="col-md-5 py-4">
                          <div className="data-table">
                            <table className="table table-borderless tab-list">
                              <tbody>
                                <tr>
                                  <td style={{ textAlign: 'right' }}>Allowances Reset</td>
                                  <td>
                                    <div className="progress">
                                      <div className="nbn-skills" style={{ '--progress-width': '40%' }} />
                                    </div>
                                  </td>
                                  <td style={{ fontWeight: 600, textAlign: 'left' }}>{postPaidDetail.expiry_date}</td>
                                </tr>
                                <tr>
                                  <td style={{ textAlign: 'right' }}>Validity</td>
                                  <td>
                                    <div className="nbn-progress"></div>
                                  </td>
                                <td style={{ fontWeight: 600, textAlign: 'left' }}>{postPaidDetail?.is_wme_prepaid === 1 ? `${postPaidDetail.activated_plan_data?.validity} Days` : 'Monthly'}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-2 py-4" onClick={()=> this.handleWmePrepaidClick(postPaidDetail?.is_wme_prepaid)} >
                          <center>
                            <Link
                              onClick={this.menuClick}
                              to={{
                                pathname: "/account-summary",
                                state: {selectedNumber:postPaidDetail.mobile_number,
                                  selectedActivation:postPaidDetail.activation_id
                                }
                              }}
                              className="kt-menu__link active"
                            >
                              <button type="button" className="btn btn-danger btn-data">
                                Manage <i className="fa fa-arrow-circle-right" aria-hidden="true"></i>
                              </button>
                            </Link>

                          </center>
                        </div>
                      </div>
                    </div>
                  ))
                }
                <br/>
            {/* Data Section 2 Ends Here */}
          </section>

          {/* Exclusive Member Deals */}
          <section className="nbn-my-account">
            <div className="nbn-my-service">
              <div className="row">
                <div className="col-md-7">
                  <h3>EXCLUSIVE MEMBER DEALS</h3>
                </div>
                <div className="col-md-5">
                  {/* You can add content here if needed */}
                </div>
              </div>
            </div>

            <div className="nbn-data-section">
              <div className="row">
                {/* Data Section 4 */}
                <div className="col-md-1 py-4">
                  <center><img src={nbnIcon} alt="nbn icon" width="60px" height="auto" /></center>
                </div>
                <div className="col-md-3 py-4">
                  <div className="nbn-data-content">
                  <center> <strong>Can't see a Service?</strong> </center>
                   <center> <p>Maybe it has its own account</p> </center>
                  </div>
                </div>
                <div className="col-md-6 py-4">
                  <div className="nbn-para-content">
                    <p style={{ textAlign: 'justify' }}>If you can't see a particular service here, it is most likely because it was created as a separate account when you ordered the service. You can merge accounts, so you can track all your services under the one My Account Login.</p>
                  </div>
                </div>
                <div className="col-md-2 py-4">
                  {/* <center><a href=""><button type="button" className="btn btn-danger btn-data">Manage <i className="fa fa-arrow-circle-right" aria-hidden="true"></i></button></a></center> */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }

}

export default PostPaidServiceList;
